import { useEffect, useState, useMemo } from "react";
import Switch from "@mui/material/Switch";
import { theme } from "../../../../theme";
import { fetchPriceCheckSettings } from "../../service";
import PricingRules from "./PricingRules";

const ONE_HOUR_RANGE = [1, 2];

const ArriveWithin = ({
    defaultRange,
    setRange,
    setIsSliderDisabled,
    isHome = false,
    range,
    calculateFutureTime,
    subSkill
}) => {
    const [settings, setSettings] = useState(null);
    const [loading, setLoading] = useState(true);

    /* -------------------- Fetch settings -------------------- */
    useEffect(() => {
        let isMounted = true;

        const loadSettings = async () => {
            try {
                const res = await fetchPriceCheckSettings();
                if (isMounted && res?.status === "Success") {
                    setSettings(res.settings);
                }
            } catch (error) {
                console.error("Error fetching price check settings:", error);
            } finally {
                isMounted && setLoading(false);
            }
        };

        loadSettings();

        return () => {
            isMounted = false;
        };
    }, []);

    /* -------------------- Derived values -------------------- */
    const hours = useMemo(
        () => (settings?.response_time_minutes ?? 0) / 60,
        [settings]
    );

    const titleText = useMemo(
        () => `Within ${hours > 1 ? `${hours} hours` : "the hour"}`,
        [hours]
    );

    const descriptionText = useMemo(
        () =>
            `Arrive within ${hours} ${hours > 1 ? "hours" : "hour"} (${
                settings?.surcharge_percentage
            }% surcharge)`,
        [hours, settings]
    );

    /* -------------------- Handlers -------------------- */
    const handleToggle = (event) => {
        const isChecked = event.target.checked;

        setRange(isChecked ? ONE_HOUR_RANGE : defaultRange);
        setIsSliderDisabled(isChecked);
    };

    /* -------------------- Early exit -------------------- */
    if (loading || !settings) return null;

    /* -------------------- UI -------------------- */
    return (
        <div
            className={
                isHome
                    ? "card card-body mt-3 job-card-bg-color-hash"
                    : "card mt-4 card-frame mx-3 job-card-bg-color"
            }
        >
            <div className={!isHome ? "card-body" : undefined}>
                {/* Header */}
                <div className="d-flex align-items-center justify-content-between">
                    <p 
                        className="mb-0 font-weight-bold text-dark"
                        // style={{ fontSize: stepFlowIsEnable ? '15px' : '' }}
                    >
                        {titleText}
                    </p>

                    <Switch
                        color={theme.main}
                        size="small"
                        onChange={handleToggle}
                    />
                </div>

                {/* Description */}
                <p className="mt-1 mb-0 text-sm text-muted"
                    // style={{ fontSize: stepFlowIsEnable ? '15px' : '' }}
                >
                    {descriptionText}
                </p>

                <PricingRules
                    isHome={isHome}
                    subSkill={subSkill}
                    range={range}
                    calculateFutureTime={calculateFutureTime}
                />
            </div>
        </div>
    );
};

export default ArriveWithin;